import { gql } from '@apollo/client';

import type { TBookingPriceDetail } from '@/infra/types/cabin';
import type { TCurrencyCode, TImage } from '@/infra/types/common';

export type TCabinCategorySearchInput = {
  cabinSeqNo: number;
  categoryCode?: string;
  fareClass?: string;
  isAccessible: boolean;
  travelParty?: { ageCategory: string; count: number }[];
};

export type TAddonDetails = {
  associationType: string;
  category: string;
  classifications: string[];
  code: string;
  name: string;
  price: TBookingPriceDetail;
  type: string;
};

export enum AddOnSellType {
  PerSailor = 'perSailor',
  PerCabin = 'perCabin',
}

export type TSortableAddOn = {
  bookingSortPriority?: number;
};

export type TAddOnFromResponse = TSortableAddOn & {
  addOnDetails: TAddonDetails | null;
  addonType: string;
  category: string;
  code: string;
  detailReceiptDescription: string;
  discoverDescription: string;
  highlightPillIcon: TImage;
  highlightPillLabel: string;
  isPerSailorPurchase: boolean;
  landscapeTitleImage: TImage;
  longDescription: string;
  longName: string;
  maximumQuantity?: number;
  name: string;
  needToKnows: string[];
  sellType: AddOnSellType;
  shortDescription: string;
  subtitle: string;
  thumbnailImage: TImage;
  wideFlyoutImage: TImage;
};

export type TAddOn = TAddOnFromResponse & {
  nestedAddOns?: TAddOnFromResponse[];
};

export type TAddonAvailabilityRequest = {
  value: { cabins: TCabinCategorySearchInput[]; currencyCode: TCurrencyCode; voyageId?: string };
};
export type TAddonAvailabilityResponse = { addOnAvailability: { addOns: TAddOnFromResponse[] }[] };

export const GQL_QUERY_ADDON_AVAILABILITY = gql`
  query ($value: AddonAvailabilityRequest) {
    addOnAvailability(value: $value) {
      cabinSeqNo
      addOns {
        shortDescription
        addonType
        name
        longName
        landscapeTitleImage {
          alt
          src
        }
        code
        detailReceiptDescription
        longDescription
        thumbnailImage {
          alt
          src
        }
        wideFlyoutImage {
          alt
          src
        }
        subtitle
        needToKnows
        addOnDetails {
          code
          category
          type
          name
          associationType
          classifications
          price {
            amount
            discount
            currencyCode
          }
        }
        category
        isPerSailorPurchase
        discoverDescription
        maximumQuantity
        highlightPillIcon {
          src
        }
        highlightPillLabel
        bookingSortPriority
        sellType
      }
    }
  }
`;
